<template>
  <div class="project">
    <h1>Déposez gratuitement votre projet de {{ survey.project }}</h1>
    <strong>Vous recevrez des devis de nos {{ survey.profession }}.</strong>

    <button type="button" class="btn btn-warning" @click.prevent="ctaCallback">Déposer une demande de devis</button>
    <small>Gratuit sans engagement</small>

    <div class="tiles">
      <div v-for="(reassurance, idx) in reassurances" :key="idx" class="tile">
        <img :src="reassurance.icon.url" :alt="reassurance.icon.alt" class="tile-icon" />
        <h3 v-html="reassurance.title"></h3>
        <span class="tile-subtitle" v-html="reassurance.subtitle"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallToAction',
  props: {
    survey: {
      type: Object,
      required: true
    },
    ctaCallback: {
      type: Function,
      required: true
    },
    reassurances: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.project {
  text-align: center;
  padding: 64px 0 32px;
}

h1 {
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0 0 8px;
}

strong {
  display: block;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  margin-bottom: 32px;
}

small {
  display: block;
  color: rgb(254, 114, 6);
  font-style: italic;
  margin-top: 8px;
}

.tiles {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
  margin-top: 64px;
}

h3 {
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.1rem;
  font-weight: 500;
  margin: 10px 0 4px;
}

.tile-subtitle {
  display: block;
  color: rgba(0, 0, 0, 0.54);
}

.tile-icon {
  width: 3rem;
}
</style>
